// src/helpers/infografia/shapeGenerator.js
// Funciones auxiliares para generar puntos de formas geométricas

/**
 * Genera puntos para un polígono regular
 * @param {number} sides - Número de lados
 * @param {number} radius - Radio del polígono
 * @returns {Array} Array de puntos {x, y}
 */
export const generateRegularPolygon = (sides, radius) => {
    const points = [];
    for (let i = 0; i < sides; i++) {
        const angle = (i * 2 * Math.PI / sides) - (Math.PI / 2); // Empezar desde arriba
        points.push({
            x: radius * Math.cos(angle),
            y: radius * Math.sin(angle)
        });
    }
    return points;
};

/**
 * Genera puntos para una estrella
 * @param {number} points - Número de puntas
 * @param {number} outerRadius - Radio exterior
 * @param {number} innerRadius - Radio interior
 * @returns {Array} Array de puntos {x, y}
 */
export const generateStar = (points = 5, outerRadius = 50, innerRadius = 25) => {
    const starPoints = [];
    for (let i = 0; i < points * 2; i++) {
        const angle = (i * Math.PI / points) - (Math.PI / 2);
        const radius = i % 2 === 0 ? outerRadius : innerRadius;
        starPoints.push({
            x: radius * Math.cos(angle),
            y: radius * Math.sin(angle)
        });
    }
    return starPoints;
};

/**
 * Genera puntos para un rombo
 */
export const generateDiamond = (width, height) => {
    return [
        { x: 0, y: -height / 2 },      // Top
        { x: width / 2, y: 0 },        // Right
        { x: 0, y: height / 2 },       // Bottom
        { x: -width / 2, y: 0 }        // Left
    ];
};

/**
 * Genera puntos para un paralelogramo
 */
export const generateParallelogram = (width, height) => {
    const skew = width * 0.2; // 20% de inclinación
    return [
        { x: skew, y: -height / 2 },
        { x: width / 2, y: -height / 2 },
        { x: width / 2 - skew, y: height / 2 },
        { x: -width / 2, y: height / 2 }
    ];
};

/**
 * Genera puntos para un trapecio
 */
export const generateTrapezoid = (width, height) => {
    const topWidth = width * 0.6; // La parte superior es 60% del ancho
    return [
        { x: -topWidth / 2, y: -height / 2 },
        { x: topWidth / 2, y: -height / 2 },
        { x: width / 2, y: height / 2 },
        { x: -width / 2, y: height / 2 }
    ];
};

/**
 * Genera un triángulo equilátero
 */
export const generateEquilateralTriangle = (size) => {
    const height = size * (Math.sqrt(3) / 2);
    return [
        { x: 0, y: -height * 0.66 },
        { x: -size / 2, y: height * 0.33 },
        { x: size / 2, y: height * 0.33 }
    ];
};
